import { render } from "./WidgetStaffLecturerChild.vue?vue&type=template&id=1fc62ed2&ts=true"
import script from "./WidgetStaffLecturerChild.vue?vue&type=script&lang=ts"
export * from "./WidgetStaffLecturerChild.vue?vue&type=script&lang=ts"

import "./WidgetStaffLecturerChild.vue?vue&type=style&index=0&id=1fc62ed2&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__